import React, { useState, useEffect, useRef } from 'react';

import Slider from 'react-slick';
import Modal from 'react-modal';
import Confetti from 'react-confetti';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Carrosel.css';
import Dado from './Dado';
import image1 from './images/cartes/1-depart.webp';
import image2 from './images/cartes/2-avoscotes.webp';
import image3 from './images/cartes/3-emptynest.webp';

import image4 from './images/cartes/4-rotondes.webp';
import image5 from './images/cartes/5-radioara.webp';
import image6 from './images/cartes/Carte6_flip.png';
import image7 from './images/cartes/Mir-wellem.png';
import image8 from './images/cartes/8-maskenada.webp';
import image9 from './images/cartes/9-kulturpass.webp';
import image10 from './images/cartes/Trois-CL.png';
import image11 from './images/cartes/11-vollekskichen.webp';
import image12 from './images/cartes/Web-Doktoren.png';
import image13 from './images/cartes/13-cafe.webp';
import image14 from './images/cartes/15-gero.webp';
import image15 from './images/cartes/14-digitalinclusion.webp';
import image16 from './images/cartes/17-ententedessocietes.webp';
import image17 from './images/cartes/16-bibliothequeccep.webp';
import image18 from './images/cartes/18-amicaledesfrançais.webp';
import image19 from './images/cartes/19-memoiresenvoyage.webp';
import image20 from './images/cartes/20-piscine.webp';
import image21 from './images/cartes/21-bounewegermusek.webp';
import image22 from './images/cartes/22-infomann.webp';
import image23 from './images/cartes/23-placeduparc.webp';
import image24 from './images/cartes/24-bounewegerneuchtigailiercher.webp';
import image25 from './images/cartes/25-danzportclub.webp';
import image26 from './images/cartes/26-cimietiere.webp';
import image27 from './images/cartes/27-parckaltreis.webp';
import image28 from './images/cartes/28-parcfusee1.webp';
import image29 from './images/cartes/29-parfusee2.webp';
import image30 from './images/cartes/30-chateaudeau.webp';
import image31 from './images/cartes/31-jardincommunautaire.webp';
import image32 from './images/cartes/32-statecamillepolfer.webp';
import image33 from './images/cartes/33-lassociazionepassarola.webp';
import image34 from './images/cartes/35-hallomnisports.webp';
import image35 from './images/cartes/34-dtunionletzebuerg.webp';
import image36 from './images/cartes/36-cooperationnordsud.webp';
import image37 from './images/cartes/37-tenisclubbonnevoie.webp';
import image38 from './images/cartes/38-arbre.webp';
import image39 from './images/cartes/39-surlestraces1.webp';
import image40 from './images/cartes/40-surlestraces2.webp';
import image41 from './images/cartes/41-lalzette.webp';
import image42 from './images/cartes/42-surlestraces3.webp';
import image43 from './images/cartes/43-stadeachillehammerel.webp';
import image44 from './images/cartes/44-lesmains.webp';
import image45 from './images/cartes/45-fmpo.webp';
import image46 from './images/cartes/46-policegrandducale.webp';
import image47 from './images/cartes/Web-medico-social.png';
import image48 from './images/cartes/48-famillecenter.webp';
import image49 from './images/cartes/49-cffm.webp';
import image50 from './images/cartes/50-multi-learn.webp';



import Pergunta from './Pergunta';
import perguntas from './PerguntasIndice'; 
import premioImage from './images/premio.webp';
import premioImageverde from './images/premio2.webp';
import jeuImage from './images/Monopoly2x2.jpg';
import audio from './sons/soundcafe.mp3';


import './anime.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion, faClose } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

import CommentJouerNovo from './CommentJouerNovo';

import { useAlteradoContext } from './AlteradoProvider';

const Teste = () => {


const {mostrarDado, setMostrarDado} = useAlteradoContext();
 const {botaoClicado, setBotaoClicado } = useAlteradoContext();
 const {mensagemnova, setMensagemnova } = useAlteradoContext();


  
   const [perguntaAtual, setPerguntaAtual] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const [slideAtivo, setSlideAtivo] = useState(false);
  const [indexSlide, setIndexSlide] = useState(null);

  const [slideIconFixo, setSlideIconFixo] = useState(null);
  const [premios, setPremios] = useState([]);
  const [premiosverde, setPremiosverde] = useState([]);

  const [modalAberto, setModalAberto] = useState(false);
  const [mensagemnovaIndex, setMensagemnovaIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [premiosChegouLimite, setPremiosChegouLimite] = useState(false);
  const [perguntaAtualIndex, setPerguntaAtualIndex] = useState(null);
  const [visible, setVisible] = useState(true);
  const [mostrarDiv2, setMostrarDiv2] = useState(false);
  const [mostrarTag, setMostrarTag] = useState(false);
  const [mostrarInfo, setMostrarInfo] = useState(false);
  const [mostraCasaVerde, setCasaVerde] = useState(false);
  const [contadorErrada, setContadorErrada] = useState(0);

  const [contadorCerta, setContadorCerta] = useState(0);
  const [show, setShow] = useState(true);
  const [animar, setAnimar] = useState(false);
  const ref = useRef(null);
  const [isActive, setIsActive] = useState(true);
  const [modalAvosCotes, setModalAvosCotes] = useState(false);
  const [animaOn, setAnimaOn ] = useState(false);



 
  const settings = {
    dots: false, infinite: true, speed: 800, slidesToShow: 4, slidesToScroll: 3, cssEase: 'linear',


    responsive: [
      {
        breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: false }
      },
      {
        breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: true, dots: false}
      },
    

   
      {
        breakpoint: 744, settings: {
          slidesToShow: 1, slidesToScroll: 1, centerMode: true, centerPadding: '0px', infinite: true, dots: false
        }
      }
    ]
  };

  const handleClickDepart = () => {
    setMostrarDado(true);
 
  };
 


   
  const handleMostrarPergunta = (pergunta, index) => {
    const perguntasIndex = perguntas[index];
    const randomIndex = Math.floor(Math.random() * perguntasIndex.length);
    const perguntaSelecionada = perguntasIndex[randomIndex];
    setPerguntaAtual(perguntaSelecionada);
    setMensagem('');
    setMostrarDado(true);
    setBotaoClicado(index);
    handlePerguntaClick(index);
    setSlideIconFixo(index);
    setIndexSlide(index);
    handleAmimaImg();
  


  };
  const handleAmimaImg = ()=>{
    setAnimaOn(false);
      requestAnimationFrame(()=>{
        setAnimaOn(true);
      })
  }
/* console.log("Index Slide",indexSlide) */

useEffect(() => {
  console.log("Contador atualizado Errada:", contadorErrada);
  }, [contadorErrada]);

  useEffect(() => {
    console.log("Contador atualizado Certa:", contadorCerta);
    }, [contadorCerta]);


  const handleResposta = (opcao) => {

  if (opcao !== perguntaAtual.respostaCorreta){
     setPremios([...premios, premioImage]);
     setContadorErrada(prev => prev + 1);
     setCasaVerde(false);
     setIsActive(true);



    }
 
  if (opcao === perguntaAtual.respostaCorreta) {
     setContadorCerta(prev => prev + 1);

     setMensagem('Continuez votre tour du quartier. Lancez le dé.');
     setMostrarDado(true);
     setMensagemnova('');
     setCasaVerde(true);
     setAnimar(true);
     setIsActive(true);
                              
     if (premios.length + 1 <= 10) {
      setPremios([...premios, premioImageverde]);

      const cloche = new Audio ('/efeitos/prix.mp3');

      cloche.volume = 0.2;

      cloche.play();

   
      }      

      if (premios.length + 1 >= 10 ) { 

        setModalAberto(true);
        setMostrarDado(true);
        setMensagem(null);
        setMensagemnova(null);
        setBotaoClicado(null);
      } 
   
    } else {
      switch (perguntaAtual.pergunta) {
        // 0
        case 'Depuis quand le service À Vos Côtés existe-t-il à Bonnevoie?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Dans quels quartiers de Luxembourg-Ville les équipes À Vos Côtés sont-elles à votre service?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Quel est l\'objectif du service À vos côtés?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        
        case 'De quelle couleur est la tenue des membres de À vos côtés?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'À Vos Côtés est un service proposé par l\'association:':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;  
//1
        case 'Quand les Rotondes ont-elles été construites?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
        case 'Les Rotondes dans le passé étaient…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Quel rôle a joué Rotondes en 2007?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Quel chanteur belge célèbre a utilisé la console de son que Rotondes utilise dans sa salle de concert, le Klub?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break; 
        case 'Pourquoi aller à Rotondes aujourd\’hui?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break; 
         
        //2   
        case 'En quelle année Radio ARA a-t-elle été officiellement créée?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break; 
        case 'En combien de langues, Radio Ara diffuse-t-elle, en 2024, un programme régulier?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;   
        case 'A qui s’adresse Radio Ara?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;  

        case 'Dans quelle langue radio Ara ne diffuse-t-elle pas de programme (pour l\'instant)?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Est-il possible de proposer une émission à Radio Ara?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
   

        //3
        case 'En quelle année Mir wëllen iech ons Heemecht weisen a-t-elle été fondée?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Quel musicien luxembourgeois connu est un des membres fondateurs de Mir wëllen iech ons Heemecht weisen?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;  
        case 'Que veut dire Mir wëllen iech ons Heemecht weisen?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Mir wëllen iech ons Heemecht weisen se trouve…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;  
        case 'Quelle patrie souhaite montrer aux nouveaux arrivants Mir wëllen iech ons Heemecht weisen?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;   
        //4
        case 'Dans quel bâtiment se trouve Maskénada?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Maskénada est…?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Maskénada a été fondée en…?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Maskénada, en 2024, dans le cadre du festival off d\'Avignon en France, a présenté la performance…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Maskénada rassemble des artistes issus:':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        //5
        case 'Combien coûte un billet d\'entrée à un événement culturel avec le Kulturpass?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Kulturpass permet aux personnes à revenu modeste de participer à la vie culturelle luxembourgeoise':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Quand le Kulturpass a-t-il été lancé?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Où se trouve le bureau de l’asbl Cultur’all / Kulturpass?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case  'Un détenteur du Kulturpass bénéficie aussi…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;    
        //6
        //3
        case 'Comment s\'appelle l\'événement de Trois C-L qui se déroule tous les 3 du mois?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Dans quel bâtiment, à Bonnevoie, se trouve Trois C-L?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Quelle forme de pratique artistique soutient Trois C-L au niveau national et international?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Comment s\'appelle un des programmes de stage de Trois C-L?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Trois C-L, c\'est…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;

        

        //7
        case 'Le prix d\'un menu (soupe, café/thé, dessert compris) à la Vollekskichen, en 2025, est de…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'La Vollekskichen est ouverte…':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Qui peut manger à la Vollekskichen?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Peut-on amener son chien à la Vollekskichen?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;
        case 'Combien de repas sont-ils servis chaque midi environ?':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
          break;


      //8
      case 'Doktere vun der Welt a un centre d’Accueil, de Soins et d’Orientation (CASO)...':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Le centre du logo de Doktere vun der Welt représente...':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Le premier objectif de Doktere vun der Welt est…':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Doktere vun der Welt fonctionne grâce à…':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Doktere vun der Welt Luxembourg fait partie du réseau international créé en 1980 par Médecins du Monde France.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;

      //10
      case 'GERO (Kompetenzzenter fir den Alter) s’adresse principalement':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Le mot GERO est dérivé de quel mot concernant les personnes âgées?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'GERO souhaite notamment…':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'GERO se trouve 1, Dernier Sol, à Bonnevoie, près de la gare.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'GERO s’engage pour la diversité, la participation, la progression, l’innovation.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      

  

      // 9
      case 'Quand l’association Digital Inclusion a-t-elle été créée?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quels appareils électroniques Digital Inclusion rénove-t-elle?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Qui peut recevoir un laptop rénové par Digital Inclusion?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'En combien de langues, en 2024, sont donnés les cours “digital skills” proposés par Digital Inclusion?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Depuis août 2024, les locaux de Digital Inclusion se trouvent':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
        

      //11
      case 'L’Entente des Sociétés de Bonnevoie édite 3 fois par an une gazette qui s’appelle':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'L’Entente des Sociétés de Bonnevoie regroupe':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Les associations membres de l’Entente des Sociétés de Bonnevoie bénéficient, notamment...':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Le numéro 1 du périodique Nouvelles de Bonnevoie édité par l’Entente des Sociétés de Bonnevoie est sorti...':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Le siège de l’Entente des Sociétés de Bonnevoie est situé au Centre Culturel à Bonnevoie au 2, rue des Ardennes à Bonnevoie.':
          setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;

      
     

      //12
      case 'Depuis quand l’Amicale des Français au Luxembourg existe-t-elle?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Quelles sont les activités de l’Amicale des Français au Luxembourg?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Il n’y a que des Français à l’Amicale des Français au Luxembourg.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'L’Amicale des Français au Luxembourg organise un apéro convivial…':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Combien coûte la cotisation annuelle de l’Amicale des Français au Luxembourg en 2024?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
     
      
      //13
      case 'Quel est l’outil au cœur des activités de Mémoires en voyage?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Quelle suite de mots est à l’opposé des valeurs de Mémoires en voyage?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Quel est l’objectif de Mémoires en voyage?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Quel est le public cible de Mémoires en voyage?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
      case 'Cette activité ne fait pas partie des activités de Mémoires en voyage':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
     

    

      //14
      case 'En quelle année Bouneweger Musek a-t-elle été fondée?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'À quelle saison Bouneweger Musek joue-t-elle son concert de gala?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quelle marche traditionnelle Bouneweger Musek joue-t-elle lors de la kermesse de Bonnevoie en juillet et à la Schueberfouer en août/septembre?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Comment se nomme la fanfare des jeunes de Bouneweger Musek?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quelle tradition les jeunes de Bouneweger Musek ont-ils depuis plus de 40 ans?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;



      //15
      case 'Depuis quand le service infoMann existe-t-il?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'A qui infoMann s’adresse-t-il?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Que propose infoMann?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Un homme peut consulter infoMann en cas de conflit conjugal, de violence et de violence domestique, pour toutes questions liées à la gestion des émotions, à la masculinité et à la parentalité.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'InfoMann se trouve désormais...':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;

      //16
      case 'Depuis quand la chorale Bouneweger Nuechtigailercher existe-t-elle?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'À partir de quel âge la chorale Bouneweger Nuechtigailercher accueille-t-elle les enfants?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'À la veille de quelle fête importante Bouneweger Nuechtigailercher chante-t-elle à l’église paroissiale?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quel jour a lieu les répétitions de la chorale Bouneweger Nuechtigailercher?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Où ont lieu les répétitions de la chorale Bouneweger Nuechtigailercher?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
     
        
     

      //17
      case 'En 2024, Danzsportclub Rout-Wäiss-Blo Lëtzebuerg a fêté ses…':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'A quoi font référence les 3 couleurs Rout, Wäiss, Blo dans le nom Danzsportclub Rout-Wäiss-Blo Lëtzebuerg?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quelle danse pratique-t-on à Danzsportclub Rout-Wäiss-Blo Lëtzebuerg?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quelle compétition organise Danzsportclub Rout-Wäiss-Blo Lëtzebuerg chaque année?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quel est le surnom de la salle de répétition de Danzsportclub Rout-Wäiss-Blo Lëtzebuerg?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
   
     

      //18
      case 'Paola CAIRO et Maria Grazia GALATI sont les journalistes de PassaParola Media Group.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quel est le nom de la revue de PassaParola Media Group?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quel film a été réalisé par PassaParola Media Group?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Sur quelle radio luxembourgeoise l’émission Voices by PassaParola est-elle diffusée?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quel livre de PassaParola Editions raconte l’histoire des Italiens au Grand-Duché?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      

      //19
      case 'Le Dësch-Tennis Union Lëtzebuerg est issu de la fusion du D.T. Bonnevoie et du D.T. Hollerich.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Combien pèse une balle de tennis de table de Dësch-Tennis Union Lëtzebuerg?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Filles et garçons peuvent jouer dans une même équipe.':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Quelle vitesse peut atteindre une balle de tennis de table?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
      case 'Depuis quand Dësch-Tennis Union Lëtzebuerg existe-t-elle?':
        setMensagem('Continuez votre tour du quartier. Lancez le dé !');
        break;
     
      
     //20
     case 'Coopération Nord-Sud organise chaque année une course à Bonnevoie…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
     case 'Coopération Nord-Sud a été créée au Luxembourg en…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
     case 'Coopération Nord-Sud est une ONG spécialisée dans le domaine de l’éducation et de la formation.':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
     case 'La lettre K du K-run organisé par Coopération Nord-Sud fait référence…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
     case 'Coopération Nord-Sud à une vision participative et centrée sur la personne du développement.':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
  

    // 21 - Tennis Club Bonnevoie
    case 'Quel est l’autre sport de raquette proposé par le Tennis Club de Bonnevoie?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Le Tennis Club de Bonnevoie a été créé, il y a…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Que cultive particulièrement le Tennis Club de Bonnevoie?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Combien de courts de tennis couverts et ouverts sont à disposition des joueurs?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Le Tennis Club de Bonnevoie est fier…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;

    
    //pergunta 22
    case 'À qui s’adresse la maison SMJ-CAB de la Fondation Maison de la Porte Ouverte?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'De quelle couleur est la façade de la maison SMJ-CAB de la Fondation Maison de la Porte Ouverte?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'La maison SMJ-CAB de la Fondation Maison de la Porte Ouverte est située boulevard Patton...':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Combien de jeunes vivent dans la maison St Martin Jeunes, Centre d’accueil de Bonnevoie?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Quand les jeunes ont-ils emménagé dans la maison SMJ-CAB de la Fondation Maison de la Porte Ouverte?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
  //23 ligue médico-social
    case 'Combien de centres médico-sociaux la Ligue gère-t-elle au Luxembourg (en 2025)?':
    setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'La Ligue propose des services...':
    setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'En 2008, la Ligue a fêté ses 100 ans.':
    setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Quel est le nom complet de la Ligue?':
    setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'La semaine nationale de prévention du surendettement co-organisée par la Ligue a lieu...':
    setMensagem('Continuez votre tour du quartier. Lancez le dé !');
    break;
 


    //pergunta 23
    case 'Familljen-Center est un service de consultation psychologique. Quelles autres activités le Familljen-Center propose-t-il?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Les enfants entre 5 et 15 ans peuvent être suivis sans leurs personnes de référence à Familljen-Center.':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Les parents peuvent consulter Familljen-Center en cas de questions concernant leur enfant à naître et/ou leur enfant intersexe.':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Depuis combien d’années Familljen-Center existe-t-il?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Les bureaux de Familljen-Center se trouvent à Bonnevoie et…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
   

    //24
    case 'CFFM signifie…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Le Centre pour Femmes, Familles et Familles Monoparentales est un service de:':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Les services du Centre pour Femmes, Familles et Familles Monoparentales sont':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Le Centre pour Femmes, Familles et Familles Monoparentales s’adresse:':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Le Centre pour Femmes, Familles et Familles Monoparentales reçoit':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
  
 
      

    //25
    case 'Luxembourg multi-LEARN Institute promeut...':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Abléck, Unplugged Messages, Wait in sont...':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Quel est le moyen de transport privilégié au Luxembourg multi-LEARN Institute?':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Luxembourg multi-LEARN Institute propose…':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;
    case 'Pour Luxembourg multi-LEARN Institute, la diversité est...':
      setMensagem('Continuez votre tour du quartier. Lancez le dé !');
      break;




  }
  setMostrarDado(true);
  setMensagemnova('');
}

};


const handleOkClick = (index) => {
  if (mensagem === 'Continuez votre tour du quartier. Lancez le dé.') {
  }
  setMensagem('');

};

useEffect(() => {
  if (premios.length >= 10) {
  setPremiosChegouLimite(true);
/*   setPremios([]); */
  } else {
    setPremiosChegouLimite(false);
  }

}, [premios]);
console.log("PREMIOS LENGHT", premios.length)

const handleMudarSlide = () => {
  const activeSlideIndex = document.querySelector('.slick-atual')?.getAttribute('data-index');
  setSlideAtivo(activeSlideIndex === '0');
};



const jogueODadoDenovo = (index) => {
  setMensagemnova('Lancez à nouveau le dé.');
  setMensagemnovaIndex(index);
  setMostrarDado(true);
};

const handleClickChegada = () => {
  setModalAberto(true); 
};

const handleCloseModal = () => {
  setModalAberto(false);
  setMostrarDado(true);
  setMensagem(null);
  setMensagemnova(null);
  setPerguntaAtual(null)
  setBotaoClicado(null);
  setPremios([]);
};

const handlePerguntaClick = (index) => {
  if (perguntaAtualIndex === index) {
      setPerguntaAtualIndex((prevState) => (prevState + 1) % perguntas.length);
  } else {
      setPerguntaAtualIndex(index);
  }
  };

const playAudio = () => {
  const somCafe = new Audio(audio); 
  somCafe.play(); 
};

const handleOpenModal = () =>{
  setModalAberto(true);
};


const handleClickReiniciar = () => {
  setModalAberto(false);;
  setMostrarDado(true);
  setMensagem(null);
  setMensagemnova(null);
  setPerguntaAtual(null)
  setBotaoClicado(null);
  setPremios([]);
    
};
useEffect(() => {
  const timer = setTimeout(() => {
  setVisible(false); 
  }, 20000); 

  return () => clearTimeout(timer); 
}, []);

const handleOpenModalAvosCotes = () =>{
  setModalAvosCotes(true);
}



  return (
    <>

{/* <alteradoProvider>
{mostrarDado && (
        <Dado></Dado>
      )} 
</alteradoProvider>

     
 */}
      <div className='envelope'>
     {/*  <div className='premio-container-envelope'>
        <div className='casa-wrap'>
        <div className='premio-casa-verte'>
                    <img src={premioImageverde}></img>
                   
                   <div className='num-certas'>{contadorCerta}</div>

                   
                </div>
                 <div className='premio-casa-rouge'>
                  <img src={premioImage}></img>
                  <div className='num-erradas'>{contadorErrada}</div>

                </div> 
        </div>
                
              </div> */}
{/*         <div className='casa-verde'></div>
 */}        
       
{/*    
{mostrarDado && (
 <Dado></Dado>
)}           
 */}
        <div className='place'>
{/*         <div className='passarobranco-depart'></div>
 */}        </div>
      <div className="prizes-container">

            {premios.map((premio, index) => (
              <div key={index} className="premio-wrapper">
                <img src={premio} alt="Prêmio" className="premio" />


                
              </div>

            ))}
                   { premiosverde.map(( premioverde, index) => (
              <div key={index} className="premio-wrapper">
                <img src={premioverde} alt="Prêmio" className="premioVerde" />


                
              </div>

            ))}


          </div>



        <div className="carousel-container">
           <div id='dado-menu-suspenso'>{mostrarDado && (<Dado></Dado>)} </div>
          
        
        <CommentJouerNovo></CommentJouerNovo>

         <div className="slide-container">
     {/*     {mostraCasaVerde && (
              <div className='casa-verde'></div>
              
            )}  
 */}
         


        

         <Slider {...settings}
  afterChange={(index) => {
    setSlideAtivo(index === 0);
  }}
>

           <div className="grid-item" id="grid1" onClick={() => { handleClickDepart() }}>
           {visible && <div className='nuvem'>
            <div className='nuvem-text'><p className='p1'>Cliquez sur Départ pour commencer.</p>
            <div className='seta'>

            </div>
            </div>

          </div>  }

              <img src={image1} alt='slide1 - Départ' />

              

            </div>



            <div className="grid-item" id="grid2">
           
            <img src={image2} alt="Slide2- À vos côtés" />
            
              <div className="link-site" id='link-2'>
              
              <a href="https://inter-actions.lu/type_portfolio/avoscotes-2/"  aria-label="Site A Vos Cotes"  target="_blank" rel="noopener noreferrer" ></a>
          </div>
              

              <button 
                className="btn"
                onClick={() => handleMostrarPergunta(perguntas[0], 0)
                  
                }
              >
                <FontAwesomeIcon icon={faQuestion} className="icon" />

              </button>
              
                 
            
 {/* 
             {!mostraCasaVerde && (
           <div className='casa-vermelha'></div>              
            )}    */}
           {/*   {!botaoClicado &&  indexSlide == 0 &&  (  
                  
                <div className='mensagem-questao'> 


{mensagem &&   ( 
  <> 
                  <div className='resposta' id='id-0'>
                
           
                    <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>
                    
                    </div>


  <div className='mensagem' id='id-0'>
    <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
    </div>
  </div>
 
                    
</>)} 
</div> 
              
)}  
              {botaoClicado === 0 && (
                <div className="perguntas">
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />

                  )}
                 

                </div>
                
                
              )}

 */}
 {botaoClicado === 0 && show &&(
   
    <div className='perguntas' id="perguntas-remove">
              
       

                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            </div>
       {/*   <button className='voir-grand' onClick={handleOpenModalAvosCotes}>Oi</button>
         <Modal  className="modal-content-card"
                isOpen={modalAvosCotes}
                onRequestClose={() => setModalAvosCotes(false)}
              
                overlayClassName="modal-overlay"
                ariaHideApp={false}
              >

                <div className='card'>
                {botaoClicado === 0 && show &&(
   
   <div className='perguntas' id="perguntas-remove">
             
      

                 {perguntaAtual && (
                   <Pergunta
                     pergunta={perguntaAtual.pergunta}
                     opcoesResposta={perguntaAtual.opcoesResposta}
                     respostaCorreta={perguntaAtual.respostaCorreta}
                     onResposta={handleResposta}
                   />
                 )}
               <div className='mensagem-questao'>

                 {mensagem && (
                   <div className='mensagem'>
                     <p>{mensagem}</p>
                   </div>
                 )}
               </div>
               </div>

             )}
                </div>
              </Modal> */}


              

            
            
              {/* {botaoClicado === 0 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
              
           
            </div> */}
            
{/*     <div className='mensagem-questao'>

                    {mensagem && (
                      <div className='mensagem'>
                        <div className='nuvem-text'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>
                    )} </div> 
                </div>
              )}
              */}

            <div className="grid-item" id="grid3" onClick={() => jogueODadoDenovo(0)}>
              <img src={image3} alt="Slide3 - Empty Nest"  />
          
              <button className="btn">
                 { /*                 <FontAwesomeIcon icon={faQuestion} className="icon" onClick={playAudio} />
                */}               
                 <FontAwesomeIcon icon={faQuestion} className="icon"/>

              </button>
              
              {mensagemnovaIndex === 0 && mensagemnova && (
                <div className='mensagemnova'>
               {/*    <p>{mensagemnova}</p> */}
               <div className='mensagem-sugestao'><p>Vous êtes invité à une balade sonore de 2,5 km dans les rues de Bonnevoie. <br></br> <br></br>
               Téléchargez l'application GOH. Prenez vos écouteurs. Rendez-vous immédiatement sur le parvis des Rotondes pour le départ.</p></div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}


              
            </div>
            <div className="grid-item" id='grid4'>
              <img src={image4} alt='slide4 - Rotondes'  />
              <div className="link-site">
             <a href="https://www.rotondes.lu/" aria-label="Site rotondes"   target="_blank" rel="noopener noreferrer"></a>
          </div>
             
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[1], 1)}>
              <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>

                  
                  
              {botaoClicado === 1 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>

                    </div>
                  )}
                </div>
                </div>

              )}
           
            </div>
             

            <div className="grid-item" id='grid5'>
              <img src={image5} alt='slide5 - Radio Ara' />
              <div className='anime'></div>

              <div className="link-site" id='link-2'>
             <a href="https://aracityradio.com/" aria-label="Lien site Radio ara"  target="_blank" rel="noopener noreferrer" ></a>
          </div>
                       
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[2], 2)}>
              <FontAwesomeIcon icon={faQuestion} className="icon" />

              </button>
            {/*   {!botaoClicado &&  indexSlide === 2 &&  (  
                  
                  <div className='mensagem-questao'> 
  
  
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>
                  
             
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>
                      
                      </div>
  
  
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>
   
                      
  </>)} 
  </div> 
                
  )} 
                {botaoClicado ===  2 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}
  
  
                
  
              </div>
 */}
  {botaoClicado === 2 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            </div>
            <div className="grid-item" id="grid6" onClick={() => jogueODadoDenovo(6)}>

            <div className='passaro-voando-1'></div>


            <img src={image6} alt="Slide6 - Passarelle" />

              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 6 && mensagemnova && (
                <div className='mensagemnova'>
{/*                   <p>{mensagemnova}</p>

 */}      <div className='mensagem-sugestao'>
        <p>Pourquoi ne pas prendre les escaliers aujourd'hui plutôt que l'ascenseur?</p>

        </div>
        
        <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
 
      
              )}
            </div>
            


            <div className="grid-item" id='grid7'>
              <img src={image7} alt='slide7' />
              <div className="link-site">
             <a href="https://onsheemecht.lu/" aria-label="Lien Mir Wellen iech ons Heemecht weisen"   target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[3], 3)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>

             
           {/*    {!botaoClicado &&  indexSlide === 3 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 3 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}
              </div> */}
               {botaoClicado === 3 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            </div>
             
            <div className="grid-item" id='grid8'>
              <img src={image8} alt='slide8 - maskenada' />
              <div className="link-site">
             <a href="https://www.maskenada.lu/" aria-label="Lien Maskénada"  target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[4], 4)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>

           
              {/* {!botaoClicado &&  indexSlide === 4 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 4 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}
              </div> */}
               {botaoClicado === 4 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            </div>
             
            <div className="grid-item" id='grid9'>
              <img src={image9} alt='slide9 - Kulturpass ' />
              <div className="link-site">
             <a href="https://www.kulturpass.lu/fr/" aria-label="Lien site Kulturpass"  target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[5], 5)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>

             {/*  
              {!botaoClicado &&  indexSlide === 5 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 5 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}
              </div>
              */}
               {botaoClicado === 5 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            </div>
            <div className="grid-item" id='grid10'>
              <img src={image10} alt='slide10 - Mir wellen iech Ons' />
              <div className="link-site">
             <a href="https://danse.lu/" aria-label="Lien Trois CL"  target="_blank" rel="noopener noreferrer" ></a>
         </div>         
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[6], 6)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
            
             {/*  {!botaoClicado &&  indexSlide === 6 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 6 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}               </div>
s*/}
                 {botaoClicado === 6 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>


            {/*grid 11*/}
            <div className="grid-item" id='grid11'>
              <img src={image11} alt='slide11 - Vollekskichen ' />
              <div className="link-site">
             <a href="https://www.cnds.lu/vollekskichen" aria-label="Lien"  target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[7], 7)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              
             {/*  {!botaoClicado &&  indexSlide === 7 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 7 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )} */}
                 {botaoClicado === 7 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

              
            {/*grid 12*/}

            {/*Doktoren vun der Welt*/}

            <div className="grid-item" id='grid12'>
 
            <img src={image12} alt='12 - Doktoren vun der Welt' />
              <div className="link-site" id='link-12'>
             <a href="https://medecinsdumonde.lu/" aria-label="Lien Doktoren vun der Welt" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[8], 8)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              
              {/* {!botaoClicado &&  indexSlide === 8 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 8 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}
              </div> */}
               {botaoClicado === 8 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            <div className="grid-item" id="grid13" onClick={() => jogueODadoDenovo(2)}>
              <img src={image13} alt="Slide13 - Café"  />

              <button className="btn">
                 { /*                 <FontAwesomeIcon icon={faQuestion} className="icon" onClick={playAudio} />
                */}               
                 <FontAwesomeIcon icon={faQuestion} className="icon"/>

              </button>
              
              {mensagemnovaIndex === 2 && mensagemnova && (
                <div className='mensagemnova'>
                  <div className='mensagem-sugestao'><p>
                  Il est grand temps de faire une pause et de prendre un rafraîchissement
                   ou une boisson chaude. Vous êtes invité à éteindre tous vos écrans pour 1 heure au moins.
               </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            
            
            <div className="grid-item" id='grid14'>
              <div className='carro-digital'></div>

            <img src={image14} alt='slide14 -Gero ' />
              <div className="link-site" id='link-12'>
             <a href="https://www.gero.lu/" aria-label="Lien Gero" target="_blank" rel="noopener noreferrer" ></a>
        </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[9], 9)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>

            {/*  {!botaoClicado &&  indexSlide === 9 &&  (                
                  <div className='mensagem-questao'> 
  {mensagem &&   ( 
    <> 
                    <div className='resposta' id='id-0'>        
                      <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                      </div>
    <div className='mensagem' id='id-0'>
      <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
      </div>
    </div>                    
  </>)} 
  </div>         
  )} 
                {botaoClicado === 9 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                   
  
                  </div>
                  
                  
                )}
              </div> */}
               {botaoClicado === 9 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 15*/}
            <div className="grid-item" id='grid15'>
              <img src={image15} alt='slide15 - Digital Inclusion ' />
              <div className="link-site" id='link-15'>

             <a href="https://digital-inclusion.lu/" aria-label="Digital Inclusion" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[10], 10)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
           
             {/*  {!botaoClicado &&  indexSlide === 10 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  10 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 10 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

              {/*grid 16*/}
              <div className="grid-item" id='grid16'>
              <img src={image16} alt='slide16 -  Centre Culturel' />
              <div className="link-site" id='link-16'>
             <a href="https://www.bonnevoie.info/" aria-label="Lien Centre Culturel" target="_blank" rel="noopener noreferrer" ></a>
           </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[11], 11)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             
            {/*   {!botaoClicado &&  indexSlide === 11 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado === 11 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 11 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 17*/}
          
            <div className="grid-item" id="grid17" onClick={() => jogueODadoDenovo(3)}>
              <img src={image17} alt="Slide17 - Bibliothèque"  />
              <div className="link-site" id='link-16'>
                         <a href="https://www.ccep-bonnevoie.lu/" aria-label="Lien Bibliothèque CCEP" target="_blank" rel="noopener noreferrer" ></a>
              </div>
                            <button className="btn">
                 { /*                 <FontAwesomeIcon icon={faQuestion} className="icon" onClick={playAudio} />
                */}               
                 <FontAwesomeIcon icon={faQuestion} className="icon"/>

              </button>
              
              {mensagemnovaIndex === 3 && mensagemnova && (
                <div className='mensagemnova'>
                   <div className='mensagem-sugestao'><p>
                   Vous pouvez visiter et emprunter un livre à la bibliothèque publique du
                   Centre Culturel et d'Éducation Populaire (2 rue des Ardennes à Bonnevoie), le mardi et le jeudi de 17h à 19h
               </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            

            {/*grid 18*/}
            <div className="grid-item" id='grid18'>
              <img src={image18} alt='slide18 - Amicale des Français' />

              <div className="link-site" id='link-15' >
             <a href="https://www.afalux.eu/" aria-label="Lien Amicale des Français" target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[12], 12)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide ===  13 &&   (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado === 13 &&  (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div>
              */}
               {botaoClicado === 12 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            <div className="grid-item" id='grid19'>
              <img src={image19} alt='slide19 - Mémoires en voyage' />

              <div className="link-site" id='link-19' >
             <a href="https://memoiresenvoyage.my.canva.site/" aria-label="Lien Mémoires en voyage" target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[13], 13)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {/* {!botaoClicado &&  indexSlide ===  14 &&   (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado === 14 &&  (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 13 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 20*/}
            <div className="grid-item" id="grid20" onClick={() => jogueODadoDenovo(4)}>
              <img src={image20} alt="slide20 - Piscine " />
              <div className='gota1d'></div>
              <div className='gota2d'></div>
              <div className='gota3d'></div>
              <div className='gota1e'></div>
              <div className='gota2e'></div>
              <div className='gota3e'></div>

              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 4 && mensagemnova && (
                <div className='mensagemnova'>
                  <div className='mensagem-sugestao'><p>
                  Passez... faire un tour à la piscine de Bonnevoie. Faites quelques longueurs.
                  </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid 21*/}
            <div className="grid-item" id='grid21'>
              <img src={image21} alt='slide21 - Bouneweger Musek' />
              <div className="link-site" id='link-20' >
             <a href="https://www.fmlb.lu/" aria-label="Lien Bouneweger Musek" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[14], 14)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
            {/*   {!botaoClicado &&  indexSlide === 15  &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  15 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 14 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

           
            {/*grid22*/}
            <div className="grid-item" id='grid22'>
              <img src={image22} alt='slide22 - InfoMann' />
              <div className="link-site" id='link-21' >
             <a href="http://www.infomann.lu/" aria-label="Lien site infomann" target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[15], 15)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide ===  16 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  16 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div>
              */}
               {botaoClicado === 15 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 23*/}
            <div className="grid-item" id="grid23" onClick={() => jogueODadoDenovo(5)}>
              <img src={image23} alt="slide23 - Place du Parc" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 5 && mensagemnova && (
                <div className='mensagemnova'>
                  <div className='mensagem-sugestao'><p>
                  Rendez-vous à la place du Parc. Vous pourrez y apprécier son kiosque lors d'un moment de détente bien mérité.
                  </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid24*/}
            <div className="grid-item" id='grid24'>
              <img src={image24} alt='slide24 - B. Nuechtigailercher ' />
              <div className="link-site" id='link-22' >
             <a href="https://www.bng.lu/" aria-label="Lien Bouneweger Nuechtigailercher" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[16], 16)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {/* {!botaoClicado &&  indexSlide === 17 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  17 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 16 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

             
            {/*grid25*/}
            <div className="grid-item" id='grid25'>
              <img src={image25} alt='slide25 - Danzsportclub RWB ' />
              <div className="link-site" id='link-18' >
             <a href="https://www.dancesport.lu/" aria-label="Lien Danzsportclub RWB Letzebuerg" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[17], 17)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {/* {!botaoClicado &&  indexSlide === 18 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  18 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 17 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 26*/}
            <div className="grid-item" id="grid26" onClick={() => jogueODadoDenovo(6)}>
              <img src={image26} alt="slide26 - Cimetière" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 6 && mensagemnova && (
                <div className='mensagemnova'>
                    <div className='mensagem-sugestao'><p>
                    Encore un petit effort pour atteindre le parc.
                  </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid 27*/}
            <div className="grid-item" id="grid27" onClick={() => jogueODadoDenovo(7)}>
              <div className='passaro-branco-2'></div>
              <div className='flor'></div>
              <img src={image27} alt="slide27 - Parc Kaltreis" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 7 && mensagemnova && (
                <div className='mensagemnova'>
                       <div className='mensagem-sugestao'><p>
                       Bienvenue au parc Kaltreis. Sports et jeux de plein air vous y attendent.                  </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
       {/*      <div className="grid-item" id="grid24" onClick={() => jogueODadoDenovo(24)}>
              <img src={image24} alt="slide24" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 24 && mensagemnova && (
                <div className='mensagemnova'>
                  <p>{mensagemnova}</p>
                </div>
              )}
            </div> 

            {/*grid 28*/}
            <div className="grid-item" id="grid28" onClick={() => jogueODadoDenovo(8)}>
              <div className='passarobranco'></div>
              <img src={image28} alt="slide28 - Parc-1 Fusée" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 8 && mensagemnova && (
                <div className='mensagemnova'>
                  <div className='mensagem-sugestao'><p>
                  Le parc Kaltreis est un lieu idéal pour les activités de plein air et de détente en famille, entre amis.
                           </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>

            <div className="grid-item" id="grid29" onClick={() => jogueODadoDenovo(9)}>
              <div className='passarobranco'></div>
              <img src={image29} alt="slide29 - Parc-2 Fusée" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 9 && mensagemnova && (
                <div className='mensagemnova'>
               <div className='mensagem-sugestao'><p>
               Une partie de l'aire de jeux du parc Kaltreis est dédiée au thème de l'espace.
                           </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid 30*/}
            <div className="grid-item" id="grid30" onClick={() => jogueODadoDenovo(10)}>
            <div className='gota1d-2'></div>
              <div className='gota2d-2'></div>
              <div className='gota1e-2'></div>
              <div className='gota2e-2'></div>
              <img src={image30} alt="slide30 - Château d'eau " />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 10 && mensagemnova && (
                <div className='mensagemnova'>
                  <div className='mensagem-sugestao'><p>
                  Le château d’eau du quartier Kaltreis à Bonnevoie a été mis en service en 1988.
                           </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>

            {/*grid 31*/}
            <div className="grid-item" id="grid31" onClick={() => jogueODadoDenovo(11)}>
              <img src={image31} alt="slide31 - Jardin communautaire " />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 11 && mensagemnova && (
                <div className='mensagemnova'>
                      <div className='mensagem-sugestao'><p>
                      Ce premier jardin communautaire a été lancé en mai 2013. Il est géré par un groupe d'habitants selon des critères écologiques. 
                           </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>

            {/*grid 32*/}
            <div className="grid-item" id="grid32" onClick={() => jogueODadoDenovo(12)}>
              <img src={image32} alt="slide32 - Stade Camille Polfer " />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 12 && mensagemnova && (
                <div className='mensagemnova'>
                 <div className='mensagem-sugestao'><p>
                 Faites un tour de terrain.
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
              {/*grid33*/}
               <div className="grid-item" id='grid33'>
              <img src={image33} alt='slide33 - L`Associazione PassaParola ' />
              <div className="link-site" id='link-14'>
             <a href="https://passaparola.info/"aria-label="Lien PassaParola" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[18], 18)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
            {/*   {!botaoClicado &&  indexSlide === 19 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  19 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div>

 */}
  {botaoClicado === 18 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>
              <div className="grid-item" id="grid34" onClick={() => jogueODadoDenovo(13)}>
              <img src={image34} alt="Hall omnisports"  />

              <button className="btn">
                 { /*                 <FontAwesomeIcon icon={faQuestion} className="icon" onClick={playAudio} />
                */}               
                 <FontAwesomeIcon icon={faQuestion} className="icon"/>

              </button>
              
              {mensagemnovaIndex === 13 && mensagemnova && (
                <div className='mensagemnova'>
                 <div className='mensagem-sugestao'><p>
                 Pour vous rendre au Hall omnisports Bonnevoie, c'est l'arrêt de bus Wisestroos (ligne 5, 6).
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>

             <div className="grid-item" id='grid34'>
              <img src={image35} alt='slide34 - DT Union Letzebuerg' />
              <div className='ball'></div>
              <div className="link-site" id='link-14'>
             <a href="https://www.dtunion.lu/"aria-label="Dësh-Tennis Union Lëtzebuerg" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[19], 19)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
            {/*   {!botaoClicado &&  indexSlide === 20  &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  20 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 19 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>
                

              )}
           
            
              </div>


     

         

            <div className="grid-item" id='grid36'>
              <img src={image36} alt='slide36 - Coordination Nord-Sud' />
              <div className="link-site" id='link-14'>
             <a href="https://www.cns-asbl.org/"aria-label="Lien Coordination Nord-Sud" target="_blank" rel="noopener noreferrer"></a>
          </div>
          
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[20], 20)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide === 21  &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  21 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 20 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            <div className="grid-item" id='grid37'>
              <img src={image37} alt='slide37 - Tennis Club Bonnevoie - Coordination Nord-Sud' />
              <div className="link-site" id='link-14'>
             <a href="https://www.tcbonnevoie.com/"aria-label="Lien Tennis Club Bonnevoie" target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[21], 21)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide ===  22 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado === 22 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 21 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 38*/}
            <div className="grid-item" id="grid38" onClick={() => jogueODadoDenovo(14)}>
              <div className='passaro-azul-arvore'></div>
              <img src={image38} alt="slide38 - arbre" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 14 && mensagemnova && (
                <div className='mensagemnova'>
               <div className='mensagem-sugestao'><p>
               Prenez un petit moment de pause auprès de votre arbre préféré.
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>

            {/*grid 39*/}
            <div className="grid-item" id="grid31" onClick={() => jogueODadoDenovo(15)}>
              <img src={image39} alt="slide39 - Sur les traces de la Revol 1" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 15 && mensagemnova && (
                <div className='mensagemnova'>
                 <div className='mensagem-sugestao'><p>
                 C'est parti pour le circuit Godchaux et ses 3 kilomètres entre verdure et rivière.
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}

            </div>
             {/*grid 40*/}
             <div className="grid-item" id="grid40" onClick={() => jogueODadoDenovo(16)}>
              <img src={image40} alt="slide40 - Sur les traces de la Revol 2 " />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 16 && mensagemnova && (
                <div className='mensagemnova'>
                     <div className='mensagem-sugestao'><p>
                     Le circuit Godchaux porte le nom de la famille à l’origine de l’industrie textile dans la vallée de l’Alzette au début du 19e siècle.
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}

            </div>
            {/*grid 32*/}
            <div className="grid-item" id="grid41" onClick={() => jogueODadoDenovo(17)}>
              <div className='peixe'></div>
              <img src={image41} alt="slide41 - L'Alzette poisson" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 17 && mensagemnova && (
                <div className='mensagemnova'>
                    <div className='mensagem-sugestao'><p>
                    Passez le pont de l'Alzette
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid 42*/}
            <div className="grid-item" id="grid42" onClick={() => jogueODadoDenovo(18)}>
            <div className='passaro-azul-p'></div>  
              <img src={image42} alt="slide42 - Sur les traces Oiseau" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 18 && mensagemnova && (
                <div className='mensagemnova'>
                   <div className='mensagem-sugestao'><p>
                   Le circuit Godchaux vous emmène également sur les traces de la révolution industrielle
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid 43*/}
            <div className="grid-item" id="grid43" onClick={() => jogueODadoDenovo(19)}>
              <img src={image43} alt="slide43" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 19 && mensagemnova && (
                <div className='mensagemnova'>
                 <div className='mensagem-sugestao'><p>
                 Faites un tour de terrain.
                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid 44*/}
              <div className="grid-item" id="grid44" onClick={() => jogueODadoDenovo(20)}>
              <img src={image44} alt="slide44" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 20 && mensagemnova && (
                <div className='mensagemnova'>
                 <div className='mensagem-sugestao'><p>
                 Bravo! Votre tour de Bonnevoie et de quelques-unes de ses associations est bientôt terminé!                    </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid45*/}
            <div className="grid-item" id='grid45'>
              <img src={image45} alt='slide45' />
              <div className="link-site" >
             <a href="https://www.fmpo.lu/"  aria-label="Site FMPO" target="_blank" rel="noopener noreferrer" ></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[22], 22)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide === 23 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  23 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 22 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*grid 46*/}
            <div className="grid-item" id="grid46" onClick={() => jogueODadoDenovo(21)}>
              <img src={image46} alt="slide46 - Police Grand-Ducale" />
              <button className="btn">
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
              {mensagemnovaIndex === 21 && mensagemnova && (
                <div className='mensagemnova'>
                  <div className='mensagem-sugestao'><p>
                  Composez le 112 pour les services de secours (urgences médicales, accidents, feux, etc.) et le 113 pour la police.                      </p>
               </div>
                 <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                </div>
              )}
            </div>
            {/*grid47*/}
            <div className="grid-item" id="grid47">
              <img src={image47} alt="slide47 - Ligue Médico-Sociale" />
              <div className="link-site" >
             <a href="https://ligue.lu/" aria-label="Ligue Médico-Sociale" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[23], 23)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide === 25  &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado === 25 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 23 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>
          
            {/*grid48*/}
            <div className="grid-item" id='grid48'>
              <img src={image48} alt='slide48' />
              <div className="link-site" >
             <a href="https://www.familljen-center.lu/" aria-label="Familljen-Center" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[24], 24)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide === 25  &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado === 25 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 24 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

             {/*grid49*/}
             <div className="grid-item" id='grid49'>
              <img src={image49} alt='slide49 - C.F.F.M' />
              <div className="link-site">
             <a href="https://fed.lu/wp/services/cffm/" aria-label="Lien C.F.F.M" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[25], 25)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide === 26  &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  26 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div>   */}
               {botaoClicado === 25 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>


            {/*grid50*/}
            <div className="grid-item" id='grid50'>
              <img src={image50} alt='slide50' />
              <div className="link-site">
             <a href="https://multi-learn.org/" aria-label="Lien site Multi-LEARN institute" target="_blank" rel="noopener noreferrer"></a>
          </div>
              <button className='btn' onClick={() => handleMostrarPergunta(perguntas[26], 26)}>
                <FontAwesomeIcon icon={faQuestion} className="icon" />
              </button>
             {/*  {!botaoClicado &&  indexSlide ===  27 &&  (                
                <div className='mensagem-questao'> 
                  {mensagem &&   ( 
                  <> 
                    <div className='resposta' id='id-0'>        
                       <div className='p-resposta' id='id-0' > <p>Réponse : </p>{perguntaAtual.respostaCorreta}</div>                 
                  </div>
                        <div className='mensagem' id='id-0'>
                          <div className='nuvem-text-mensagem'><p className='p-mensagem-'>{mensagem}</p>
                        </div>
                      </div>                    
                  </>)} 
               </div>         
              )} 
                {botaoClicado ===  27 && (
                  <div className="perguntas">
                    {perguntaAtual && (
                      <Pergunta
                        pergunta={perguntaAtual.pergunta}
                        opcoesResposta={perguntaAtual.opcoesResposta}
                        respostaCorreta={perguntaAtual.respostaCorreta}
                        onResposta={handleResposta}
                      />
  
                    )}
                  </div>                 
                )}
              </div> */}
               {botaoClicado === 26 && (
                <div className='perguntas'>
                  {perguntaAtual && (
                    <Pergunta
                      pergunta={perguntaAtual.pergunta}
                      opcoesResposta={perguntaAtual.opcoesResposta}
                      respostaCorreta={perguntaAtual.respostaCorreta}
                      onResposta={handleResposta}
                    />
                  )}
                <div className='mensagem-questao'>

                  {mensagem && (
                    <div className='mensagem'>
                      <p>{mensagem}</p>
                    </div>
                  )}
                </div>
                </div>

              )}
           
            
              </div>

            {/*teste--------------------------------------------------------------------*/}
            
              

           
                        </Slider>   
                        </div>
          <div className='modal-fim'>     
            <Modal
              isOpen={modalAberto}
              onRequestClose={() => setModalAberto(false)}
              className="modal-content-2"
              overlayClassName="modal-overlay"
              ariaHideApp={false}
             >
             
                  <Confetti
                  width={window.innerWidth}
                  height={window.innerHeight}
                  numberOfPieces={100}
                  gravity={0.3}
                />

              
            
              <div className='close-modal'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleCloseModal} />
              </div>

              <img src={jeuImage} alt="Fim" className="flag" /*style={{ width: '200px', height:'200px', marginTop: '10px' }}*/ />
              <div className='Parabens'>{/*<p8> Vous avez répondu à {premios.length} questions :  </p8>*/} <br></br> 
                <div className='premio-container'>
                  <div className='premio-casa-verte'>
                    <img src={premioImageverde}></img>
                   
                   <div className='num-certas'>{contadorCerta}</div>

                   
                </div>
                <div className='premio-casa-rouge'>
                  <img src={premioImage}></img>
                  <div className='num-erradas'>{contadorErrada}</div>

                </div>
              </div>
{/*                - Maisons rouges : {contadorErrada}
 */}               </div>
           
              <div className='button-reiniciar'> 
                
              <button className="bg-blue-500 text-gray px-4 py-2 rounded hover: transition" onClick={handleClickReiniciar}>
              Continuer votre tour </button>
              

              </div>
           
                <div className='downlaod-mensagem'> {/* <p8>Cliquez pour télécharger le Monopoly</p8> */}</div>
                
         
 <div>
       <div className="button-reiniciar"> {/* <p8>Cliquez pour télécharger le Monopoly</p8> */}

                    <a href="/pdf/plateau-de-jeu-2025.pdf" download="plateau-de-jeu-2025.pdf">
    
                    <button className="bg-blue-500 text-gray px-4 py-2 rounded hover: transition">Téléchargez le plateau du jeu</button>
                    </a>
                  
                </div>
  </div> 
 
   </Modal>
          </div> 

        </div>

      </div>
    </>

  );
};


export default Teste;